export default __webpack_public_path__ + "static/media/img-pp.fccd746d.png";